import { useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import { trackPageView } from '../../services/tracking';
import { updateReducerAndForm } from '../../services/subscription';
import FrequencyOption from './FrequencyOption';
import { StyledFrequenciesBox } from './style';
import frequencies from './frequencies';

import { Button } from '../button';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';
import { ErrorLabel } from '../input';
import { PageBottom } from '../pageBottom';

import Summary from '../summary';

const Frequency = ({ history }) => {
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);
  const initialValues = { ...subscription };

  const validate = (values) => {
    const errors = {};

    if (!values.frequency){
      errors.frequency = 'Escolha uma frequência para continuar';
    }

    return errors;
  }

  const handleClick = (frequency, setFieldValue) => {
    updateReducerAndForm({
      frequency: parseInt(frequency.frequency)
    }, setFieldValue);
  }

  const handleSubmit = (values) => {
    dispatch(completeStep(3));
    history.push('/entrega');
  }

  useEffect(() => {
    dispatch(updateSubscription({ frequencyPage: 'frequency' }));

    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={validate}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <PageHeader>
              <small>Frequência</small>
              <h1>Com qual frequência devemos enviar os seus cafés?</h1>
              <p>Você só será cobrado por envio feito.</p>
            </PageHeader>

            <StyledFrequenciesBox>
              {frequencies.map((frequency, i) => {
                return <FrequencyOption
                  {...frequency}
                  key={i}
                  currentFrequency={frequency}
                  current={values.frequency}
                  onClick={(e) => { handleClick(frequency, setFieldValue); }}
                />
              })}
            </StyledFrequenciesBox>

            <ErrorLabel name="frequency" />

            <PageBottom>
              <h4>Nenhuma das frequências acima te atende?</h4>

              <Link to="/frequencia-personalizada">
                Escolha sua frequência ideal
              </Link>
            </PageBottom>

            <Summary />

            <FormActions backUrl="/plano-gateway" backDescription="Sua caixinha">
              <Button
                type="submit"
                icon="angle-right"
                align="right"
                description="Endereço de entrega"
              >
                Continuar
              </Button>
            </FormActions>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default withRouter(Frequency);
